import http from "./http";

export const getResultListApi = (date, page = 0, size = 50) =>
    http.get("/api/player/result/list", { params: { date, page, size } });
